export const BADGE_DEFS = [
  { id: "first_test",        icon: "🎯", label: "First Steps",       desc: "Completed your first spelling test" },
  { id: "first_meaning",     icon: "📖", label: "Word Detective",     desc: "Completed your first meaning quiz" },
  { id: "perfect",           icon: "💯", label: "Perfect Score",      desc: "Got 100% on a spelling test" },
  { id: "perfect_meaning",   icon: "🌟", label: "Meaning Master",     desc: "Got 100% on a meaning quiz" },
  { id: "perfect_3",         icon: "🔱", label: "Triple Perfect",     desc: "3 perfect spelling scores" },
  { id: "streak_3",          icon: "🔥", label: "On Fire",            desc: "3-day practice streak" },
  { id: "streak_7",          icon: "⚡", label: "One Week Strong",    desc: "7-day practice streak" },
  { id: "streak_14",         icon: "👑", label: "Fortnight Champion", desc: "14-day practice streak" },
  { id: "streak_30",         icon: "🏆", label: "Unstoppable",        desc: "30-day practice streak" },
  { id: "mastered_5",        icon: "🏅", label: "Word Master",        desc: "Mastered 5 spelling words" },
  { id: "mastered_20",       icon: "📚", label: "Spelling Champ",     desc: "Mastered 20 spelling words" },
  { id: "mastered_50",       icon: "🎓", label: "Scholar",            desc: "Mastered 50 spelling words" },
  { id: "meaning_5",         icon: "💡", label: "Meaning Maven",      desc: "Mastered 5 word meanings" },
  { id: "meaning_20",        icon: "🧠", label: "Vocab Virtuoso",     desc: "Mastered 20 word meanings" },
  { id: "ten_tests",         icon: "💪", label: "Dedicated",          desc: "Completed 10 spelling tests" },
  { id: "tests_25",          icon: "🚀", label: "Committed",          desc: "Completed 25 spelling tests" },
  { id: "meaning_10",        icon: "🔍", label: "Quiz Enthusiast",    desc: "Completed 10 meaning quizzes" },
  { id: "improvement",       icon: "📈", label: "Improving",          desc: "Beat your previous spelling score" },
  { id: "speed_demon",       icon: "⚡", label: "Speed Speller",      desc: "Finished a test in under 3 minutes" },
  { id: "comeback",          icon: "💫", label: "Comeback Kid",       desc: "Scored 80%+ after scoring under 60%" },
  { id: "first_synonym",     icon: "🔤", label: "Word Twin",          desc: "Completed your first synonyms quiz" },
  { id: "first_antonym",     icon: "🔄", label: "Flip Side",          desc: "Completed your first antonyms quiz" },
  { id: "perfect_synonym",   icon: "💯", label: "Synonym Master",     desc: "Got 100% on a synonyms quiz" },
  { id: "perfect_antonym",   icon: "💯", label: "Antonym Master",     desc: "Got 100% on an antonyms quiz" },
];

export function checkNewBadges(userId, data, newSession, prevSessions) {
  const existing = new Set((data.badges?.[userId] || []).map(b => b.id));
  const earned = [];
  const streak = data.streaks?.[userId] || 0;
  const mastered = Object.entries(data.progress || {}).filter(([k, v]) => k.startsWith(userId) && !k.includes("_meaning_") && v.mastered).length;
  const meaningMastered = Object.entries(data.meaningProgress || {}).filter(([k, v]) => k.startsWith(userId) && v.mastered).length;
  const allSpellSessions = [...prevSessions.filter(s => s.type !== "meaning" && s.type !== "synonym" && s.type !== "antonym"), ...(newSession.type !== "meaning" && newSession.type !== "synonym" && newSession.type !== "antonym" ? [newSession] : [])];
  const allMeaningSessions = [...prevSessions.filter(s => s.type === "meaning"), ...(newSession.type === "meaning" ? [newSession] : [])];
  const isSpelling = newSession.type !== "meaning" && newSession.type !== "synonym" && newSession.type !== "antonym";
  const isMeaning  = newSession.type === "meaning";
  const isSynonym  = newSession.type === "synonym";
  const isAntonym  = newSession.type === "antonym";

  function add(id) { if (!existing.has(id)) earned.push(id); }

  if (isSpelling) add("first_test");
  if (isMeaning)  add("first_meaning");

  if (isSpelling && newSession.score === 100) {
    add("perfect");
    const perfects = allSpellSessions.filter(s => s.score === 100).length;
    if (perfects >= 3) add("perfect_3");
  }
  if (isMeaning && newSession.score === 100) add("perfect_meaning");

  if (streak >= 3)  add("streak_3");
  if (streak >= 7)  add("streak_7");
  if (streak >= 14) add("streak_14");
  if (streak >= 30) add("streak_30");

  if (mastered >= 5)  add("mastered_5");
  if (mastered >= 20) add("mastered_20");
  if (mastered >= 50) add("mastered_50");
  if (meaningMastered >= 5)  add("meaning_5");
  if (meaningMastered >= 20) add("meaning_20");

  if (allSpellSessions.length >= 10) add("ten_tests");
  if (allSpellSessions.length >= 25) add("tests_25");
  if (allMeaningSessions.length >= 10) add("meaning_10");

  const prevSpell = prevSessions.filter(s => s.type !== "meaning");
  if (isSpelling && prevSpell.length > 0 && newSession.score > prevSpell[prevSpell.length - 1].score) add("improvement");

  if (isSpelling && newSession.timeSec < 180 && newSession.total >= 10) add("speed_demon");
  if (isSpelling && newSession.score >= 80 && prevSpell.some(s => s.score < 60)) add("comeback");

  if (isSynonym) add("first_synonym");
  if (isAntonym) add("first_antonym");
  if (isSynonym && newSession.score === 100) add("perfect_synonym");
  if (isAntonym && newSession.score === 100) add("perfect_antonym");

  return earned.map(id => ({ id, earnedAt: Date.now() }));
}
